/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { AaiChannelItem } from '../../asyncapi/models/AaiChannelItem';
import { AaiDocument } from '../../asyncapi/models/AaiDocument';
import { AaiOperation } from '../../asyncapi/models/AaiOperation';
import { Aai20NodeFactory } from '../../asyncapi/v2/models/Aai20NodeFactory';
import { AbstractCommand } from '../AbstractCommand';
import { JsonCompat } from '../../compat/JsonCompat';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { NodeCompat } from '../../compat/NodeCompat';
import { Document } from '../../core/models/Document';
import { AaiMessage } from '../../asyncapi/models/AaiMessage';

/**
 * A command used to create a new operation in a channel.
 * @author laurent.broudoux@gmail.com
 * @extends AbstractCommand
 * @class
 */
export class NewOperationCommand_Aai20 extends AbstractCommand {
    public _channel : string;

    public _opType : string;

    public _created : boolean;

    public constructor(_channel? : any, opType? : any) {
        if(((typeof _channel === 'string') || _channel === null) && ((typeof opType === 'string') || opType === null)) {
            let __args = arguments;
            super();
            if(this._channel===undefined) this._channel = null;
            if(this._opType===undefined) this._opType = null;
            if(this._created===undefined) this._created = false;
            if(this._channel===undefined) this._channel = null;
            if(this._opType===undefined) this._opType = null;
            if(this._created===undefined) this._created = false;
            (() => {
                this._channel = _channel;
                this._opType = opType;
            })();
        } else if(_channel === undefined && opType === undefined) {
            let __args = arguments;
            super();
            if(this._channel===undefined) this._channel = null;
            if(this._opType===undefined) this._opType = null;
            if(this._created===undefined) this._created = false;
            if(this._channel===undefined) this._channel = null;
            if(this._opType===undefined) this._opType = null;
            if(this._created===undefined) this._created = false;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[NewOperationCommand_Aai20] Executing.");
        let adoc : AaiDocument = <AaiDocument>document;
        this._created = false;
        if(this.isNullOrUndefined(adoc.channels)) {
            return;
        }
        let channel : AaiChannelItem = /* get */((m,k) => m[k]===undefined?null:m[k])(adoc.channels, this._channel);
        if(this.isNullOrUndefined(channel)) {
            return;
        }
        if(!/* equals */(<any>((o1: any, o2: any) => { if(o1 && o1.equals) { return o1.equals(o2); } else { return o1 === o2; } })("subscribe",this._opType)) && !/* equals */(<any>((o1: any, o2: any) => { if(o1 && o1.equals) { return o1.equals(o2); } else { return o1 === o2; } })("publish",this._opType))) {
            return;
        }
        let nodeFactory : Aai20NodeFactory = new Aai20NodeFactory();
        let operation : AaiOperation = nodeFactory.createOperation(channel, this._opType);
        operation.message = nodeFactory.createMessage(operation, null);
        operation.message.payload = JsonCompat.objectNode();
        switch((this._opType)) {
        case "subscribe":
            channel.subscribe = operation;
            break;
        case "publish":
            channel.publish = operation;
            break;
        }
        this._created = true;
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[NewOperationCommand_Aai20] Reverting.");
        if(!this._created) {
            return;
        }
        let adoc : AaiDocument = <AaiDocument>document;
        if(this.isNullOrUndefined(adoc.channels)) {
            return;
        }
        let channel : AaiChannelItem = /* get */((m,k) => m[k]===undefined?null:m[k])(adoc.channels, this._channel);
        if(this.isNullOrUndefined(channel)) {
            return;
        }
        NodeCompat.setProperty(channel, this._opType, null);
    }
}
NewOperationCommand_Aai20["__class"] = "io.apicurio.datamodels.cmd.commands.NewOperationCommand_Aai20";
NewOperationCommand_Aai20["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




